module.exports = __webpack_public_path__ + "static/media/vrchat.7be9d018.svg";